import { t } from "@/i18n-js/instance";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { IconButton } from "@circle-react-uikit/HeaderV3/IconButton";

const localeNamespace = "settings.emails.templates";

export function CardOptions({
  openDeleteModal,
  openRenameTemplateModal,
}: {
  openDeleteModal: () => void;
  openRenameTemplateModal: () => void;
}) {
  return (
    <Dropdown
      direction="bottom-end"
      menuButtonEl="div"
      button={
        <IconButton
          name="16-menu-dots-horizontal"
          ariaLabel={t([localeNamespace, "menu"])}
          className="bg-primary border-primary rounded-full border"
        />
      }
    >
      <Dropdown.ItemWithLink onClick={openRenameTemplateModal}>
        {t([localeNamespace, "rename_template"])}
      </Dropdown.ItemWithLink>
      <Dropdown.ItemWithLink hasDanger onClick={openDeleteModal}>
        {t([localeNamespace, "delete_template"])}
      </Dropdown.ItemWithLink>
    </Dropdown>
  );
}
